// Loud looping alarm using the Web Audio API (no asset needed).
let ctx = null;
let intervalId = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

// Resume the audio context on the first user gesture so later alarms can play.
export function primeAudio() {
  getCtx();
}

function beep() {
  const c = getCtx();
  if (!c) return;
  const now = c.currentTime;
  // two-tone chirp
  [880, 1320].forEach((freq, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "square";
    osc.frequency.value = freq;
    const start = now + i * 0.28;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.5, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.25);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(start);
    osc.stop(start + 0.26);
  });
}

export function startAlarm() {
  if (intervalId) return;
  beep();
  intervalId = setInterval(beep, 1200);
}

export function stopAlarm() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

export function isAlarmRunning() {
  return intervalId !== null;
}
